const companyList = require('./src/companyList').default
const departmentOchart = require('./src/ochart/departmentOchart').default
// const ochart = require('./src/ochart').default
const ochart = require('./src/ochart/companyOchart').default
const twothird = require('./src/twothird').default
const mappingOchart = require('./src/mappingOchart').default
const kpiListTable = require('./src/component/kpiListTable').default
const kpiCompanyTable = require('./src/component/kpiCompanyTable').default
const kpiMappingTable = require('./src/component/kpiMappingTable').default
const kpiProjectTable = require('./src/component/kpiProjectTable').default
const radishScore = require('./src/component/radishScore').default
const finance = require('./src/finance').default
const offerTable = require('./src/offerTable').default
// const fullCompany = require('./src/fullCompany').default
const TagShow = require('./src/component/TagShow.vue').default
const Bulletin = require('./src/component/Bulletin.vue').default
const MulEditDialog = require('./src/exportComponent/mul-edit-dialog.vue').default
const RadishExperiencePopper = require('./src/exportComponent/radish-experience-popper.vue').default
const InterviewGrade = require('./src/component/InterviewGrade.vue').default
const InterviewGradeList = require('./src/InterviewGradeList.vue').default
const serchMoney = require('./src/exportComponent/serch-money.vue').default
const companySuperList = require('./src/exportComponent/company-super-list.vue').default
const companyFundChart = require('./src/exportComponent/company-fund-chart.vue').default
const formerYearsList = require('./src/exportComponent/former-years-list.vue').default
const createCompany = require('./src/createCompany').default
const selectCompany = require('./src/hunting/selectCompany').default

export {
  // fullCompany,
  ochart,
  twothird,
  companyList,
  mappingOchart,
  departmentOchart,
  kpiListTable,
  kpiCompanyTable,
  kpiMappingTable,
  kpiProjectTable,
  radishScore,
  finance,
  offerTable,
  TagShow,
  Bulletin,
  MulEditDialog,
  RadishExperiencePopper,
  InterviewGrade,
  InterviewGradeList,
  serchMoney,
  companySuperList,
  companyFundChart,
  formerYearsList,
  createCompany,
  selectCompany,
}
